<script>
  import { Spinner } from '@sveltestrap/sveltestrap';

  export let bezel = true;
  export let height = 200;
  export let html = '';
  export let loading = false;
  export let scale = 1;
  export let title = '';
  export let width = 100;
</script>

<div>
  {#if loading}
    <div class="loading" style="width: {width}px; height: {height}px">
      <Spinner color="white" size="sm" />
    </div>
  {:else}
    <svg xmlns="http://www.w3.org/2000/svg" {width} {height} class:bezel>
      <foreignObject width={width / scale} height={height / scale} transform="scale({scale})">
        <body xmlns="http://www.w3.org/1999/xhtml">
          <iframe
            {title}
            width={width / scale}
            border="0"
            height={height / scale}
            srcdoc={html}
            class="m-0"
            scrolling="no"
          ></iframe>
        </body>
      </foreignObject>
    </svg>
  {/if}
</div>

<style>
  :root {
    --border-width: 2px;
  }

  iframe {
    pointer-events: none;
  }

  svg {
    border-radius: 0.357rem;
    border: 0;
  }

  .bezel {
    border: var(--border-width) solid var(--color-gray-700);
    border-radius: 0.5rem;
  }

  .loading {
    align-items: center;
    display: flex;
    justify-content: center;
  }
</style>
